import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 病院掲示板一覧
 *
 * 病院掲示板データの一覧を返す
 */
export class FetchMessage implements APIRequest<Monitaro.FetchMessageResponse> {
  response: Monitaro.FetchMessageResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/messages`
  }
}

/**
 * 病院掲示板データの取得
 *
 * 指定されたIDの病院掲示板情報を返す
 */
export class GetMessage implements APIRequest<Monitaro.GetMessageResponse> {
  response: Monitaro.GetMessageResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(message: string) {
    this.path = `/messages/${message}`
  }
}
